module.exports = __webpack_public_path__ + "static/media/visualizacion-logo-caracol-tv-1987-2000-01@3x.b4153f53.png";